export enum AppEventType {
  logOut,
}

export class AppEvent {
  constructor(public type: AppEventType, public data: any = null) {}
}
